import React from 'react';
import PropTypes from 'prop-types';
import { getMessage , getCropBasedMessage } from 'util/locale';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

import { searchStatuses } from 'constants/values';

import { Spinner } from '@tcc/crate';

const baseString = 'vra-seed-product-search-status';
const classString = classNames({
  [`${baseString}`]: true
});
const SeedProductSearchStatus = ({
  searchStatus
}) => {
  const cropId = useSelector(getActiveCropId);

  let content = (
    <p>{getMessage('text__seed-product-selector')}</p>
  );

  if (searchStatus === searchStatuses.PENDING) {
    content = (
      <Spinner size='24' />
    );
  } else if (searchStatus === searchStatuses.ERROR) {
    content = (
      <p>{getMessage('help-text__failure--search')}</p>
    );
  } else if (searchStatus === searchStatuses.COMPLETE) {
    content = (
      <p>{getCropBasedMessage({ key:'help-text__seed-finder-empty-search', cropId })}</p>
    );
  }

  return (
    <section className={classString}>
      {content}
    </section>
  );
};
SeedProductSearchStatus.propTypes = {
  searchStatus: PropTypes.string.isRequired
};
export default SeedProductSearchStatus;
